import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar,MatSnackBarHorizontalPosition,MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CommonService } from "../shared/services/common.service";

@Component({
  selector: 'app-add-manangers',
  templateUrl: './manangers.component.html',
  styleUrls: ['./manangers.component.scss']
})
export class AddManangersComponent implements OnInit {

  @Input("new-item-id") newItemId;
  showAddManager:boolean = false;
  first_name:string = "";
  last_name:string = "";
  email:string = "";
  phone:string = "";
  jobTitle = "";
  Hposition:MatSnackBarHorizontalPosition = "right";
  VPosition:MatSnackBarVerticalPosition = "top";
  @ViewChild("addmanager") addmanager:NgForm;
  street1:string = "";
  street2:string = "";
  city:string = "";
  postal_code:string = "";
  selectedCountry = {
    ID:"",Name:""
  }
  selectedState = null;
  @Output("added") added = new EventEmitter<any>();


  constructor(private toast:MatSnackBar,private service:CommonService) { }

  ngOnInit(): void {
  }

  cancelManager(){
    this.showAddManager = false;
    this.first_name = null;
    this.last_name = null;
    this.email = null;
    this.phone = null;
    this.jobTitle = null;
  }
  addManager(){
    if (
        this.first_name == null || 
        this.last_name == null || 
        this.email == null || 
        this.phone == null || this.jobTitle == null  
        ) { return;}
    if (
        this.first_name.trim() == '' || 
        this.last_name.trim() == '' || 
        this.email.trim() == '' || 
        this.phone.trim() == '' || this.jobTitle.trim() == ''
        ){ return; }

      let props = {
          // client_id
          state_id:null,
          first_name: this.first_name,
          last_name: this.last_name,
          street1: this.street1,
          street2: this.street2,
          city: this.city,
          postal_code: this.postal_code,
          country_id: this.selectedCountry ? this.selectedCountry.ID : null,
          email: this.email,
          phone: this.phone,
          jobTitle: this.jobTitle
      };

      if (this.selectedState) {
          props.state_id = this.selectedState.ID;
      }
      this.service.saveManager(props).subscribe(
        response=>{          
          if (response.data.ErrorCode == 200) {
              this.showConfirmationToast(response.data);
              this.showAddManager = false;
              this.newItemId = response.data.Data.ID;
              this.added.emit(response.data.Data);
              this.first_name = null;
              this.last_name = null;
              this.email = null;
              this.phone = null;
              this.jobTitle = null;
          } else {
              console.error(response);
              this.showConfirmationToast(response.data);
          }
        },
        err=>{
          console.log(err);
        }
      )
  }
  enable(){
    this.showAddManager = true;
  }

  showConfirmationToast(response) {
    let successMessage = '';
    if (response.ErrorCode == 200) {
        successMessage = 'A new manager has been added';
    } else {
        successMessage = response.Message.Details;
    }
    this.toast.open(successMessage, "Got it", {
      duration: 2000,horizontalPosition:this.Hposition,
      verticalPosition:this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }

  canProceed(){
    if (
        !this.first_name || this.first_name == null ||
        !this.last_name || this.last_name == null ||
        !this.email || this.email == null ||
        !this.phone || this.phone == null || 
        !this.jobTitle || this.jobTitle == null 
    ) {
        return false;
    }
    if (
        this.first_name.trim() == '' ||
        this.last_name.trim() == '' ||
        this.email.trim() == '' ||
        this.phone.trim() == '' || 
        this.jobTitle.trim() == ''
    ) {
        return false;
    }

    return true;
  }

}
